import { EXCHANGES_AVAILABLE, EXCHANGE_TYPE_SELECTOR, TExchangesAvailable } from '@/core/constants'

export const getExchangeTypeFromSession = (): TExchangesAvailable | undefined => {
  const sessionExchange = sessionStorage.getItem(EXCHANGE_TYPE_SELECTOR)
  return sessionExchange && EXCHANGES_AVAILABLE.includes(sessionExchange as TExchangesAvailable)
    ? (sessionExchange as TExchangesAvailable)
    : undefined
}
